import {isArray, isEmpty} from 'lodash';
import {Filter} from 'src/js/lib/filtering';
import {FilterNode} from 'src/js/model/filters_config';

import {MUI_SELECT_ID_PROPERTY, REACT_SELECT_ID_PROPERTY} from './filtering_constants';

export function getSelectOptionIdProperty(isMui) {
  return isMui ? MUI_SELECT_ID_PROPERTY : REACT_SELECT_ID_PROPERTY;
}

export function isListFilteredFunction(selectedFilters: Filter[], filtersWithDefaultValue: FilterNode[]) {
  const isListFiltered = !selectedFilters.every((selectedFilter) => {
    let returnValue = false;
    const selectedFilterValue = selectedFilter.getValue();

    filtersWithDefaultValue.forEach((filterWithDefaultValue) => {
      if (filterWithDefaultValue.getName() === selectedFilter.getProperty()) {
        if (isArray(selectedFilterValue)) {
          // We support only one default value from config for now, thus we check only first value from selected filter
          returnValue = selectedFilterValue.length === 1 && filterWithDefaultValue.getDefaultValue() === selectedFilterValue[0];
        } else if (!isArray(selectedFilterValue)) {
          returnValue = filterWithDefaultValue.getDefaultValue() === selectedFilterValue;
        }
      }
    });
    return returnValue;
  });

  return (isEmpty(selectedFilters) && !isEmpty(filtersWithDefaultValue)) || selectedFilters.length < filtersWithDefaultValue.length
    ? true
    : isListFiltered;
}

export enum UserActionEnum {
  Open = 'Open',
  Close = 'Close',
  ClickHierarchy = 'ClickHierarchy',
  EmptyInput = 'EmptyInput',
  AnyInput = 'AnyInput',
  ClickAway = 'ClickAway',
}

export function getStateFromUserActionEnum(
  isAutocompleteOpen: boolean,
  isPopperOpen: boolean,
  isMulti: boolean,
  userAction?: UserActionEnum
) {
  let returnIsAutocompleteOpen = false;
  let returnIsPopperOpen = false;

  switch (userAction) {
    case UserActionEnum.Open:
      returnIsPopperOpen = !isPopperOpen || isMulti;
      break;
    case UserActionEnum.Close:
      returnIsAutocompleteOpen = false;
      returnIsPopperOpen = false;
      break;
    case UserActionEnum.ClickHierarchy:
      returnIsPopperOpen = isMulti;
      break;
    case UserActionEnum.EmptyInput:
      if (isAutocompleteOpen) {
        returnIsAutocompleteOpen = false;
        returnIsPopperOpen = true;
      }
      break;
    case UserActionEnum.AnyInput:
      returnIsAutocompleteOpen = true;
      returnIsPopperOpen = false;
      break;
    case UserActionEnum.ClickAway:
      returnIsPopperOpen = false;
      break;
    default:
      returnIsAutocompleteOpen = false;
      returnIsPopperOpen = false;
  }

  return {
    returnIsAutocompleteOpen,
    returnIsPopperOpen,
  };
}
